import { Collapse } from '@blueprintjs/core';
import React from 'react';
import _ from 'lodash';
import {
  IRosterCustomer,
  IRosterCustomerWithBookings,
} from 'common-components/roster-control/interfaces/roster-interfaces';
import { ColumnGroupHeader } from './ColumnGroupHeader';
import { CustomersColumn } from './CustomersColumn';
import { EmptySideColumn } from './EmptySideColumn';

function getCustomerBookings(customer: IRosterCustomer, bookings: IRosterCustomerWithBookings[]) {
  return _.get(
    _.find(bookings, (booking) => booking.customerId === customer.customerId),
    'bookings',
  );
}

interface CustomersSideColumnProps {
  customers: IRosterCustomer[];
  isCustomersOpen: boolean;
  setCustomersOpen: (isOpen: boolean) => void;
  bookings: IRosterCustomerWithBookings[];
}

export function CustomersSideColumn({
  customers = [],
  setCustomersOpen = () => {},
  isCustomersOpen = true,
  bookings = [],
}: CustomersSideColumnProps) {
  const hasCustomers = _.size(customers) > 0;

  return (
    <div>
      <ColumnGroupHeader text='Customers' onClick={() => setCustomersOpen(!isCustomersOpen)} isOpen={isCustomersOpen} />
      <Collapse isOpen={isCustomersOpen} keepChildrenMounted={false}>
        <div className='flex-column'>
          {!hasCustomers && <EmptySideColumn />}
          {_.map(customers, (customer) => (
            <CustomersColumn
              key={customer.customerId}
              customer={customer}
              bookings={getCustomerBookings(customer, bookings)}
            />
          ))}
        </div>
      </Collapse>
    </div>
  );
}
